import { Injectable } from "@angular/core";

import {
  State,
  CompositeFilterDescriptor,
  FilterDescriptor,
  isCompositeFilterDescriptor
} from "@progress/kendo-data-query";

import { GridDataEntity } from "./grid-data-entity";

import { GridColumnDefinition } from "./grid-column-definition";

import { GridColumnMode } from "./grid-column-mode";
import { Filter } from "../../DTO/filtering/filter";
import { FilterOperator } from "../../DTO/filtering/filter-operator";
import { FilterGroup } from "../../DTO/filtering/filter-group";
import { Query } from "../../DTO/querying/query";
import { kendoPropertySplitter } from "../../shared.constants";

@Injectable({
  providedIn: "root"
})
export class GridDataConverterService {
  private static setFilterOperatorValue(newFilter: Filter, operator: string) {
    switch (operator) {
      case "eq":
        newFilter.Operator = FilterOperator[FilterOperator.Equals];
        break;
      case "isnull":
        newFilter.Operator = FilterOperator[FilterOperator.Equals];
        newFilter.Value = null;
        break;
      case "isempty":
        newFilter.Operator = FilterOperator[FilterOperator.Equals];
        newFilter.Value = "";
        break;
      case "neq":
        newFilter.Operator = FilterOperator[FilterOperator.NotEquals];
        break;
      case "isnotnull":
        newFilter.Operator = FilterOperator[FilterOperator.NotEquals];
        newFilter.Value = null;
        break;
      case "isnotempty":
        newFilter.Operator = FilterOperator[FilterOperator.NotEquals];
        newFilter.Value = "";
        break;
      case "startswith":
        newFilter.Operator = FilterOperator[FilterOperator.BeginsWith];
        break;
      case "endswith":
        newFilter.Operator = FilterOperator[FilterOperator.EndsWith];
        break;
      case "lt":
        newFilter.Operator = FilterOperator[FilterOperator.LessThan];
        break;
      case "lte":
        newFilter.Operator = FilterOperator[FilterOperator.LessThanOrEqualTo];
        break;
      case "gt":
        newFilter.Operator = FilterOperator[FilterOperator.GreaterThan];
        break;
      case "gte":
        newFilter.Operator =
          FilterOperator[FilterOperator.GreaterThanOrEqualTo];
        break;
      case "contains":
        newFilter.Operator = FilterOperator[FilterOperator.Contains];
        break;
      case "doesnotcontain":
        newFilter.Operator = FilterOperator[FilterOperator.NotContains];
        break;
      default:
      // Don't set
    }
  }

  stateToQuery(currentState: State): Query {
    const returnValue = new Query();

    if (currentState.take) {
      returnValue.Take = currentState.take;
      returnValue.Skip = currentState.skip;
    }
    if (currentState.sort) {
      returnValue.Orderings = [];
      for (let index = 0; index < currentState.sort.length; index++) {
        const element = currentState.sort[index];
        const splitColumnName = element.field
          .toString()
          .split(kendoPropertySplitter);
        const item = {
          Group: splitColumnName[0],
          Header: splitColumnName[1],
          Ascending: element.dir === "asc"
        };
        returnValue.Orderings.push(item);
      }
    }
    if (currentState.filter) {
      returnValue.FilterGroup = new FilterGroup();
      returnValue.FilterGroup.And = true;
      returnValue.FilterGroup = this.filterBuilder(currentState.filter);
    }
    if (currentState.group) {
    }

    return returnValue;
  }

  filterBuilder(
    filters: CompositeFilterDescriptor | FilterDescriptor
  ): FilterGroup {
    const newFilter = new FilterGroup();
    if (isCompositeFilterDescriptor(filters)) {
      for (let index = 0; index < filters.filters.length; index++) {
        const element = filters.filters[index];
        newFilter.And = filters.logic === "and";
        newFilter.FilterGroups.push(this.filterBuilder(filters.filters[index]));
      }
    } else {
      const filterToAdd = new Filter();

      const splitColumnName = filters.field
        .toString()
        .split(kendoPropertySplitter);

      filterToAdd.Group = splitColumnName[0];
      filterToAdd.Header = splitColumnName[1];
      filterToAdd.Value = filters.value;

      // WARNING Could break with new versions of kendo
      GridDataConverterService.setFilterOperatorValue(
        filterToAdd,
        filters.operator as string
      );
      newFilter.Filters.push(filterToAdd);
    }
    return newFilter;
  }

  convertDataFromApi(data: any): GridDataEntity {
    let gridData: { [id: string]: any } = {};
    const displayedData: GridDataEntity = new GridDataEntity();

    for (let index = 0; index < data.length; index++) {
      gridData = {};
      const a = data[index].Id;
      const b = "Id";
      gridData[b] = a;
      gridData["Local" + kendoPropertySplitter + "Documents"] =
        data[index].HasDocuments;
      for (
        let innerIndex = 0;
        innerIndex < data[index].DataFields.length;
        innerIndex++
      ) {
        const x = data[index].DataFields[innerIndex].Header;
        const y = data[index].DataFields[innerIndex].Value;
        const z = (x as string).replace(".", kendoPropertySplitter);
        gridData[z] = y;
      }
      displayedData.data.push(gridData);
    }

    return displayedData;
  }

  sortAndRenameColumns(
    columns: GridColumnDefinition[]
  ): GridColumnDefinition[] {
    columns = columns.sort((x1, x2) => x1.Index - x2.Index);
    for (let index = 0; index < columns.length; index++) {
      columns[index].PropertyName =
        columns[index].EntityName +
        kendoPropertySplitter +
        columns[index].PropertyName;
      if (columns[index].GridDisplayType === ("Bytes" as unknown)) {
        columns[index].Header += " (MB)";
      }
    }
    columns = columns.filter(x => x.Visibility !== GridColumnMode.None);
    return columns;
  }
}
